"use strict";
angular.module("internal.exams").controller("InternalExamPacket", ["$scope",
    "EXPackets",
    "$stateParams",
    "EXForms",
    "$uibModal",
    "$state",
    "LicenseCategoryLevels",
    "$window",
    function ($scope, EXPackets, $stateParams, EXForms, $uibModal, $state, LicenseCategoryLevels, $window) {
        $scope.packet = { activeStatus: true };
        $scope.packet.passingRequirments = [];
        $scope.formsToAdd = [];
        $scope.certs = [];
        $scope.editableRequirments = [];
        $scope.passRequirments = [{ name: "Required", id: "1" }, { name: "Not Required", id: "0" }];
        $scope.formsIDList = "";
        $scope.loading = true;
        $scope.formsLoading = true;
        $scope.addingForm = false;
        $scope.addingRequirment = false;
        $scope.saveMessage = $stateParams.saveMessage;
        $scope.validOrder = true;
        $scope.setAvailableForms = function () {
            EXForms.get().then(function (ExamForm) {
                ExamForm.records.forEach(function (f) {
                    if (f.active == true) {
                        if ($scope.formsIDList.indexOf(f.id) < 0) {
                            $scope.formsToAdd.push(f);
                        }
                    }
                })
            })
        }
        $scope.removeForm = function (form) {
            $scope.formsToAdd.push(form.examForm);
            $scope.packet.examPacketForms.splice($scope.packet.examPacketForms.indexOf(form), 1);
        }
        $scope.addForm = function () {
            $scope.addingForm = true;
            $scope.ngModel = $scope.ngModel || "";
            if ($scope.formsToAdd.length > 0) {
                $uibModal.open({
                    animation: true,
                    templateUrl: paths.app + 'exams/components/exam-packet/exam-packet-modal.html',
                    controller: 'ExamPacketModalController',
                    resolve: {
                        forms: function () {
                            return $scope.formsToAdd;
                        }
                    }
                }).result.then(function (result) {
                    if (result != null) {
                        result.examForm = {};
                        result.examForm.name = result.name;
                        result.examForm.id = result.id;
                        result.sortOrder = $scope.packet.examPacketForms.length + 1;
                        result.maxFailedAttempts = 0;
                        result.ExamFormId = result.id;
                        result.ExamPacketId = $stateParams.id;
                        result.id = null;
                        $scope.packet.examPacketForms.push(result);
                        $scope.formsToAdd.splice($scope.formsToAdd.indexOf(result), 1);
                    }
                });
                $scope.addingForm = false;
            } else alert('No more forms available for this packet.');
            $scope.addingForm = false;
        }
        LicenseCategoryLevels.get({ entity_id: '5384A3C9-A244-41CC-92C1-6423E4561B83' }).then(function (licenseCategoryLevels) {
            licenseCategoryLevels.forEach(function (licenseCategoryLevel) {
                $scope.certs.push({
                    name: licenseCategoryLevel.combined_name,
                    id: licenseCategoryLevel.id
                });
            })
        });
        if ($stateParams.id != null) {
            EXPackets.getPassingRequirments($stateParams.id).then(function (passingList) {
                $scope.editableRequirments = passingList.records;
                $scope.setRequirments();
            });
        }
        $scope.save = function () {
            $scope.saving = true;
            $scope.packet.passingRequirments.forEach(function (pr) {
                pr.examForms = [];
                $scope.packet.examPacketForms.forEach(function (ef) {
                    if (ef.examPacketPassingRequirementGroupId == pr.id) pr.examForms.push(ef.examForm);
                })
            });
            $scope.packet.examPacketForms.forEach(function (ef) {
                if (ef.examPacketPassingRequirementGroupId == '1') ef.passingRequired = 1;
                else ef.passingRequired = 0;
            });
            EXPackets.save($scope.packet).then(function (returnpacket) {
                if (returnpacket.id != null) {
                    if ($stateParams.id != null) {
                        $scope.saveMessage = "Record updated successfully";
                        $window.scrollTo(0, 0);
                    } else {
                        $scope.saveMessage = "Packet created successfully";
                        $state.go("internal.exams.administrative.packet", {
                            id: returnpacket.id,
                            saveMessage: "Record created successfully"
                        });
                    }
                } else {
                    $scope.saveMessage = returnpacket.message;
                }
            });
            $scope.saving = false;
        };
        $scope.delete = function () {
            if ($scope.packet.numOfSessions > 0) {
                $scope.saveMessage = "Cannot delete packet. It is currently being used for a session.";
            } else {
                EXPackets.delete($scope.packet.id).then(function () {
                    $state.go("internal.exams.administrative.packets")
                });
            }
        }
        $scope.checkSortOrder = function () {
            var numList = new Array();
            var validSort = true;
            $scope.saveMessage = null;
            $scope.validOrder = true;
            $scope.packet.examPacketForms.forEach(function (pf) {
                numList.push(pf.sortOrder);
            });
            var sortedList = numList.slice().sort();
            for (var i = 0; i < sortedList.length - 1; i++) {
                if (sortedList[i] == sortedList[i + 1]) {
                    validSort = false;
                    $scope.validOrder = false;
                }
            }
            if (!validSort) $scope.saveMessage = "Invalid sort order. Correct before saving.";
        }
        $scope.copy = function () {
            EXPackets.copy($scope.packet.id).then(function (newPacketId) {
                if (newPacketId.id != null) {
                    $state.go("internal.exams.administrative.packet", {
                        id: newPacketId.id,
                        saveMessage: newPacketId.message
                    }, {
                        reload: true
                    })
                } else {
                    if (newPacketId.message.indexOf("already") > 0) $scope.saveMessage = newPacketId.message + " Copy of " + $scope.packet.name + ".";
                    else $scope.saveMessage = newPacketId.message;
                }
            });
        }
        $scope.clear = function () {
            $state.go("internal.exams.administrative.packet", {
                id: ''
            }, {
                reload: true
            })
        }
        $scope.setRequirments = function () {
            $scope.passRequirments = [{
                name: "Required",
                id: "1"
            }, {
                name: "Not Required",
                id: "0"
            }];
            $scope.editableRequirments.forEach(function (requirment) {
                var format = {
                    name: "Conditional - " + requirment.name + " (1 of " + requirment.minPassedForms + ")",
                    id: requirment.id
                };
                $scope.passRequirments.push(format);
            });
            $scope.packet.passingRequirments = angular.copy($scope.editableRequirments);
        }
        $scope.manageReq = function () {
            $scope.addingRequirment = true;
            $scope.ngModel = $scope.ngModel || "";
            $uibModal.open({
                animation: true,
                templateUrl: paths.app + 'exams/components/exam-packet/exam-packet-requirment-modal.html',
                controller: 'ExamPacketRequirmentModalController',
                backdrop: 'static',
                resolve: {
                    requirments: function () {
                        return $scope.editableRequirments;
                    },
                    packetID: function () {
                        return $scope.packet.id;
                    }
                }
            }).result.then(function (result) {
                if (result != null) {
                    $scope.editableRequirments = result;
                    $scope.setRequirments();
                }
            });
            $scope.addingRequirment = false;
        }
        $scope.determineClasses = function (isEven) {
            var classes = "row no-margin exam-packet-form-list";
            if (isEven) classes += " even";
            return classes;
        };
        if ($stateParams.id != null) {
            EXPackets.getByID($stateParams.id).then(function (Packet) {
                $scope.packet = Packet;
            }).then(function () {
                $scope.packet.examPacketForms.forEach(function (f) {
                    if ($scope.formsIDList == "") $scope.formsIDList = f.examFormId
                    else $scope.formsIDList += ',' + f.examFormId;
                    $scope.packet.examPacketPassingRequirementGroups.forEach(function (pr) {
                        pr.examForms.forEach(function (prf) {
                            if (prf.id == f.examFormId) {
                                f.examPacketPassingRequirementGroupId = pr.id;
                            }
                        })
                    })
                    if (f.passingRequired == '1') {
                        f.examPacketPassingRequirementGroupId = 1
                    };
                    if (f.examPacketPassingRequirementGroupId == null) f.examPacketPassingRequirementGroupId = 0;
                })
            }).then(function () {
                $scope.setAvailableForms();
                $scope.setRequirments();
                $scope.formsLoading = false;
                $scope.loading = false;
            });
        } else {
            $scope.packet.examPacketForms = [];
            $scope.setAvailableForms();
            $scope.setRequirments();
            $scope.formsLoading = false;
            $scope.loading = false;
        }
    }]);